<template>
  <b-form-group
    label="Ürün Kategorisi"
    label-for="id_product_categories"
  >
    <validation-provider
      #default="{ errors }"
      name="Ürün Kategorisi"
      rules="required"
    >
      <v-select
        v-model="dataItem.id_product_categories"
        :options="dataList"
        label="title"
        :reduce="item => item.id"
        placeholder="Giriniz"
      >
        <template v-slot:option="option">
          {{ option.title }}
          <div v-if="option.id_product_categories && option.mainProductCategory">
            <b-badge variant="light-secondary">
              <feather-icon icon="CornerDownRightIcon" />
              {{ option.mainProductCategory.title }}
            </b-badge>
          </div>
          <div v-else>
            <b-badge variant="light-warning">
              <feather-icon icon="StarIcon" />
              Üst Kategorisi Yok
            </b-badge>
          </div>
        </template>
        <template v-slot:selected-option="option">
          <b-badge
            v-if="option.mainProductCategory"
            variant="light-secondary"
            class="mr-1"
          >
            <feather-icon icon="CornerDownRightIcon" />
            {{ option.mainProductCategory.title }}
          </b-badge>
          {{ option.title }}

        </template>
      </v-select>
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup, BBadge,
} from 'bootstrap-vue'
import { required } from '@validations'
import vSelect from 'vue-select'

export default {
  name: 'ProductsCategorySelect',
  components: {
    BFormGroup,
    vSelect,
    ValidationProvider,
    BBadge,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['productCategories/dataList']
    },
    dataItem() {
      return this.$store.getters['products/dataItem']
    },
  },
  created() {
    localize('tr')
    this.getDataList()
  },
  methods: {
    getDataList() {
      this.$store.dispatch('productCategories/getDataList', {
        select: {
          id: true,
          title: true,
          mainProductCategory: true,
          id_product_categories: true,
        },
        where: {
          id_product_categories: {
            not: null,
          },
        },
      })
    },
  },
}
</script>
